module.exports = __webpack_public_path__ + "img/Italian_Salad_Sopressata.79ae8ad9.jpg";